import React from "react";
import { useLocation } from "react-router-dom";
import { payrollInsightsData } from "./data";
import "../assests/CSS/PayrollInsights.css";

const PayrollInsights = () => {
  const location = useLocation();
  const searchData = location.state?.searchData || {};
  const selectedService = searchData.search || "EOR/PEO/AOR";
  const selectedCountry = searchData.location || "United States";

  const { heading, image, items } = payrollInsightsData.getInsights(selectedService, selectedCountry);

  return (
    <div className="insights-container">
      <div className="insights-left">
        <img 
          src={image} 
          alt={`${selectedCountry} insights`} 
          className="insights-image"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/assets/images/placeholder.png";
          }}
        />
        <h2 className="insights-heading">{heading}</h2>
      </div>
      <div className="insights-right">
        {items.length > 0 ? (
          items.map((item, index) => (
            <div key={index} className="insight-item">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))
        ) : (
          <div className="no-insights">
            <p>No insights available for {selectedService} in {selectedCountry}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PayrollInsights;